/** Shared marked-PDF download: rasterize chosen sheets with their takeoffs,
 * highlights and search marks burned in (used by the gallery and the Plans
 * page mini-list). */
import { buildMarkedPdf, downloadBlob } from "./markedPdf";
import { loadPdf } from "./pdfSetup";
import { fetchDrawingBytes } from "./api";
import { isTiff } from "./theme";
import { getPageState } from "./pageState";

export async function downloadMarkedSheets(drawing, pageNums, docState, { searchBoxesByPage = {}, onProgress } = {}) {
  if (isTiff(drawing)) {
    throw new Error("Marked PDF export isn't available for TIFF-converted drawings yet");
  }
  // whole-document export: reuse the cached doc if the drawing is open,
  // otherwise one full sequential download beats hundreds of range requests
  const pdfDoc = await loadPdf(drawing.drawing_id, async () => ({ data: await fetchDrawingBytes(drawing.drawing_id) }));
  const pages = [];
  for (const n of [...pageNums].sort((a, b) => a - b)) {
    const ps = getPageState(docState, drawing.drawing_id, n);
    const page = await pdfDoc.getPage(n);
    const base = page.getViewport({ scale: 1 });
    const rot = (((base.rotation + (ps.rotation || 0)) % 360) + 360) % 360;
    const vp = page.getViewport({ scale: 1, rotation: rot });
    pages.push({
      pageNum: n,
      rotation: ps.rotation || 0,
      unitH: (1000 * vp.height) / vp.width,
      items: (docState.items || []).filter((i) => i.fileId === drawing.drawing_id && i.page === n),
      highlights: ps.highlights || [],
      searchBoxes: searchBoxesByPage[n] || [],
    });
  }
  const { blob, filename } = await buildMarkedPdf(pdfDoc, 0, 1000, pages, drawing.name, onProgress);
  downloadBlob(blob, filename);
}
